'use client';

import { load, BotDetectionResult } from '@fingerprintjs/botd';

import { LoggerFactory } from '@videoblocks/typescript-logger';

const logger = LoggerFactory.create('botDetection');

export async function detectBot(): Promise<BotDetectionResult> {
    try {
        const botd = await load();
        const result = botd.detect();
        return result;
    } catch (error: unknown) {
        logger.error(error, 'Bot detection failed');
        throw error;
    }
}
